// Pasife alınan firma ekranı ve firmaya özel anlık olay dinleyicisi
import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Ban, LogOut } from 'lucide-react';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sadece bu firmanın oturumu sunucudan anlık bildirim alır; ayrıca 423 yanıtı gelirse durum yenilenir
export const useFirmEvents = (enabled, onStatusChange) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const token = localStorage.getItem('token');
    const es = token ? new EventSource(`${API}/firm/events?token=${encodeURIComponent(token)}`) : null;
    es?.addEventListener('company_status', onStatusChange);
    es?.addEventListener('permit_status', () => window.dispatchEvent(new Event('firm-permit-status')));
    es?.addEventListener('nav_counts', () => window.dispatchEvent(new Event('nav-counts')));
    es?.addEventListener('five_star', () => window.dispatchEvent(new Event('nav-counts')));
    es?.addEventListener('firm_access', () => window.dispatchEvent(new Event('firm-access')));
    es?.addEventListener('doc_mask_fix', (ev) => {
      const d = JSON.parse(ev.data || '{}');
      toast.warning(`Sağlık raporu için maskeleme düzeltmesi istendi: ${d.reason || ''}`, { duration: 10000 });
      window.dispatchEvent(new Event('firm-permit-status'));
    });
    es?.addEventListener('doc_mask_fixed', () => toast.info('Firma bir sağlık raporunun maskelemesini düzeltip yeniden onaya gönderdi', { duration: 8000 }));
    // Yeniden bağlanınca kaçırılan olaylar sunucudan yeniden oynatılır (Last-Event-ID); tutulamadıysa sunucu 'resync' gönderir
    es?.addEventListener('resync', () => {
      onStatusChange();
      ['firm-permit-status', 'nav-counts', 'firm-access'].forEach(e => window.dispatchEvent(new Event(e)));
    });
    const id = axios.interceptors.response.use(undefined, (error) => {
      if (error.response?.status === 423) onStatusChange();
      return Promise.reject(error);
    });
    return () => { es?.close(); axios.interceptors.response.eject(id); };
  }, [enabled, onStatusChange]);
};

export const FirmPassiveScreen = ({ company, onLogout }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="firm-passive-screen">
    <div className="max-w-lg w-full bg-white rounded-2xl border border-rose-200 shadow-sm p-8 space-y-5">
      <div className="h-12 w-12 rounded-full bg-rose-100 flex items-center justify-center">
        <Ban className="h-6 w-6 text-rose-600" />
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900">Firma süreciniz pasife alınmıştır</h1>
        <p className="text-sm text-slate-600">
          <b>{company?.name}</b> firmasının süreci İSG birimi tarafından pasife alınmıştır. Bu süre içinde sistemde işlem yapamazsınız.
        </p>
      </div>
      <div className="rounded-lg bg-rose-50 border border-rose-100 p-4" data-testid="firm-passive-reason">
        <p className="text-xs font-medium text-rose-700 mb-1">Açıklama:</p>
        <p className="text-sm text-slate-800 whitespace-pre-wrap">{company?.passive_reason || '-'}</p>
      </div>
      <p className="text-sm text-slate-700" data-testid="firm-passive-until">
        {company?.passive_until ? <>Pasiflik süresi: <b>{company.passive_until.split('-').reverse().join('.')}</b> tarihine kadar</> : 'Pasiflik süresi: Süresiz'}
      </p>
      {company?.passive_at && (
        <p className="text-xs text-slate-400">Pasife alınma: {new Date(company.passive_at).toLocaleString('tr-TR')}</p>
      )}
      <Button variant="outline" onClick={onLogout} className="w-full" data-testid="firm-passive-logout">
        <LogOut className="h-4 w-4 mr-2" />Çıkış Yap
      </Button>
    </div>
  </div>
);
